<template>
    <div class="page successBox">
        <div class="container min-h-100 d-flex flex-column justify-content-between text-center pt-4">
            <div class="row">
                <div class="col-12">
                    <div class="descktopMediaBox">
                        <div class="h1 text-center">Thanks!</div>
                    </div>
                    <div class="textBox  mb-4">
                        <p v-if="type">Great! Check your text messages for instructions on resetting your password.</p>
                        <p v-else>Great! Check your email for instructions on resetting your password.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="imgBox mediaHideOnDesctop mb-4">
                        <div v-if="type">
                            <img :src="getStaticImage('icons/account/sms.png')" alt="">
                        </div>
                        <div v-else>
                            <img :src="getStaticImage('icons/account/email.png')" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="btnBox">
                        <router-link :to="{name: 'Home'}" class="btnlink zbg inv">
                            Back to Home
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ResetPasswordFinish",
        created() {
            this.$store.commit("shared/setTopBar", {active: false});
            if (this.$route.params.type == "email") {
                this.type = false;
            } else {
                this.type = true
            }
        },
    }
</script>
